// This is a rewrite from what could be found in Home/Index.cshtml that was loaded on the initial page load of the Razor-based RIS

import { type NavigateFunction } from 'react-router';
import * as API from '../API';
import LockType from '../Models/LockType';

function CheckForReportPagesToOpen(navigate: NavigateFunction): void {
    void API.general.getReportsToOpen()
        .then((data: any) => {
            if (data.ReportsToOpen.length === 0) {
                return;
            }

            void API.general.openReport({ reportsToOpen: data.ReportsToOpen })
                .then((data: any): void => {
                    const reports = data.outputObjects;
                    if (reports.length === 0) {
                        return;
                    }
                    for (const report of reports) {
                        void API.locks.tryCreateLockFile({ LockType: LockType.Report, RecordID: report.ProcedureIDs })
                            .then((data: any) => {
                                if (data.Done) {
                                    navigate(report.URLToOpen);
                                }
                                else if (!data.Done) {
                                    window.showLockedFileDialog(data, report.URLToOpen);
                                }
                            })
                            .catch((err) => console.error('[PACSDriven] tryCreateLockFile error:', err));
                    }
                })
                .catch((err) => console.error('[PACSDriven] openReport error:', err));
        })
        .catch((err) => {
            console.error('[PACSDriven] WCF getReportsToOpen error:', err);
        });
}

function CheckForOrderPagesToOpen(navigate: NavigateFunction): void {
    void API.general.getOrdersToOpen()
        .then((data: any) => {
            const accessionNumbers = data.AccessionNumbers;
            const orderNumbers = data.OrderNumbers;
            if (accessionNumbers.length + orderNumbers.length === 0) {
                return;
            }

            void API.general.openOrders({ accessionNumbers, orderNumbers })
                .then((data: any) => {
                    if (data.URLsToOpen && data.URLsToOpen.length > 0) {
                        for (const urlToOpen of data.URLsToOpen) {
                            navigate(urlToOpen);
                        }
                    }
                })
                .catch((err) => console.error('[PACSDriven] openOrders error:', err));
        })
        .catch((err) => {
            console.error('[PACSDriven] WCF getOrdersToOpen error:', err);
        });
}

export default function StartupPACSDriven(navigate: NavigateFunction): void {
    console.log('[PACSDriven] Startup');
    setInterval(CheckForReportPagesToOpen, 1000, navigate);
    setInterval(CheckForOrderPagesToOpen, 1000, navigate);
}
